import React from 'react';
import './RegisterCta.scss';
import ArrowCta from '../../../assets/images/arrowCTA.png';

interface RegisterCtaProps {
  signUpToggleHandler: () => void;
}

function RegisterCta({ signUpToggleHandler }: RegisterCtaProps) {

  return (
    <section id="Register-Now" className="blur-bg">
      {/* <img src={registerNow}></img> */}
      {/* <img src="https://png.pngtree.com/png-clipart/20230529/original/pngtree-special-offer-tag-shape-free-vector-png-image_9173639.png" alt="" /> */}
      <h1 className="cta-heading animate__animated animate__fadeInDown">
        Enjoy 30 Days of Free Access – Register Now to Unlock All Premium
        Features.
      </h1>
      <div className="d-table mx-auto mt-5 position-relative animate__animated animate__fadeInUp">
        <button
          className="btn btn-light focus-btn"
          onClick={signUpToggleHandler}
        >
          Register Now
        </button>
        <img src={ArrowCta} className="cta-arrow" alt="cta-arrow" />
      </div>
    </section>
  );
}

export default RegisterCta;
